import React from "react";
import { appDomain, getLogoImagePath } from "../../Util/general-config";
import { ROUTE_CONSTANT } from "../../Util/Constants";
import { useNavigate } from "react-router-dom";

type Props = {};

const NoTemplate = (props: Props) => {
  const navigate = useNavigate();
  const HomeNavigate = () => {
    if (process.env.NODE_ENV == "development") {
      navigate(ROUTE_CONSTANT.LANDINGPAGE);
    } else {
      window.location.href = appDomain();
    }
  };
  return (
    <div>
      <div onClick={HomeNavigate} className="displaymobile">
        <img
          className="legalsimpli-logo height-37 mt-3 mb-3 ps-20"
          src={getLogoImagePath()}
          alt="PDFsimpli"
          draggable="false"
        />
      </div>
      <div id="steps-form" className="col-lg">
        <div className="vehicle-steps-content">
          <div className="tab">
            <div id="step_id_0" className="row">
              <div className="col-md-12">
                <div className="steps-mobile 0000 text-center">
                  <h4>Template Not Found !</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoTemplate;
